import { mapState } from "vuex";
import isEmpty from "lodash/isEmpty";
export default {
  computed: {
    ...mapState("personalInfo", ["selectedEmployee"]),
  },
  methods: {
    setEmployee() {
      if (!isEmpty(this.selectedEmployee)) {
        this.selectedEmp = this.selectedEmployee;
      }
    },
  },
  created() {
    this.setEmployee();
  },
};
